import React, { useState } from "react";
import { Collapse, NavItem, NavLink } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const SubMenu = (props) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const toggleMenu = () => setCollapsed(!collapsed);
  const { icon, title, items, toggle } = props;

  const linkHighlited = (path) => {
    const defaultClasses =
      "!flex items-center  relative px-3 py-2 text-gray-900 rounded-lg hover:bg-gray-100 hover:text-primary text-sm font-medium gap-2 w-full cursor-pointer";

    if (location.pathname !== path) return defaultClasses;

    return `${defaultClasses} text-primary bg-gray-100`;
  };

  const ActiveLinkHighlight = ({ path }) => {
    const isActive = location.pathname === path;
    return (
      <div
        className={`absolute top-1/2 -translate-y-1/2 right-2 w-1 h-5 bg-[#2dbdf2] rounded-md ${isActive ? "" : "hidden"
          }`}
      />
    );
  };
  function normalizePath(target) {
    if (!target) return "#";
    // Remove accidental protocol like "http://admin"
    if (/^https?:\/\//.test(target)) return target;
    return target.startsWith("/") ? target : `/${target}`;
  }

  return (
    <>
      <NavItem className={classNames({ "menu-open": !collapsed })}>
        <NavLink
          onClick={toggleMenu}
          className="!flex items-center justify-between relative px-3 py-2 text-gray-900 rounded-lg hover:bg-gray-100 hover:text-primary text-base font-medium gap-2 w-full cursor-pointer"
        >
          <div className="w-full flex  gap-2  items-center">
            {icon}
            <span>{title}</span>
          </div>
          <div className="">
            {collapsed ? (
              <FontAwesomeIcon icon={faAngleDown} />
            ) : (
              <FontAwesomeIcon icon={faAngleUp} />
            )}
          </div>
        </NavLink>
        <Collapse
          isOpen={!collapsed}
          navbar
          className={classNames("items-menu !pb-0.5 space-y-2", {
            "mb-1": !collapsed,
          })}
        >
          {items.map((item, index) => (
            <>
              {
                item.hidden ? null : (
                  <NavItem onClick={toggle} key={index} className="pl-4 py-1">
                    <NavLink
                      tag={Link}
                      to={normalizePath(item.target)}
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick();
                          return;
                        }
                        setCollapsed(false);
                      }}
                      className={`
                  ${linkHighlited(item.target)}
                  
                 ${location.pathname === "/" + item.target ? "text-primary" : ""
                        }`}

                    // style={{ fontSize: "15px" }}
                    >
                      {item.icon}
                      {item.title}
                      <ActiveLinkHighlight path={item.target} />
                    </NavLink>
                  </NavItem>
                )
              }
            </>
          ))}
        </Collapse>
      </NavItem>
    </>
  );
};

export default SubMenu;
